import { render, staticRenderFns } from "./Fragments.vue?vue&type=template&id=2840b03e&"
import script from "./Fragments.vue?vue&type=script&lang=js&"
export * from "./Fragments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports